import { removeUidFromObject } from "./sb-fixer";
import { ISBEmbeddedSvods } from "../types/sb";
import { ComponentNames } from "../constant";

export const addPackageDetailsToEmbeddedSvods = (args: {
  embeddedSvods: ISBEmbeddedSvods[];
  epochSvodsData: any;
  packageConfig: any;
  componentType: any;
  signaturePackages?: any;
  svodMapping?: any;
  isSatellite?: boolean;
  excludedSvods?: any[];
  pkgId?: string;
  pkgType?: string;
  singlePackageView?: boolean;
  singlePackageConfig?: any;
}) => {
  const { epochSvodsData, packageConfig, componentType, signaturePackages, svodMapping, isSatellite, pkgId, pkgType, singlePackageView, singlePackageConfig, excludedSvods } = args;
  let { embeddedSvods } = args;

  const pkgMatchText = isSatellite ? "DTV_TV" : "ATT_TV";
  // Adding packageListSystem for Embedded & Included SVODs retrieved from epoch getOffers
  let filteredPackages =
    Array.isArray(packageConfig || []) && packageConfig?.length > 0 ?
      packageConfig?.filter(
        (pkg: any) => pkg?.id?.startsWith?.(pkgMatchText) &&
            epochSvodsData &&
            Object.keys(epochSvodsData || {}).includes(pkg?.queryparam)
      ) :
      [];
  filteredPackages = filteredPackages?.reduce?.((acc, curr) => {
    if (!curr?.queryparam) {
      return acc;
    }
    acc[curr?.queryparam] = curr?.id;
    return acc;
  }, {});
  embeddedSvods = embeddedSvods && removeUidFromObject?.(embeddedSvods || []) || [];
  embeddedSvods = embeddedSvods?.length > 0 && embeddedSvods?.map?.((item: ISBEmbeddedSvods) => {
    const packageListSystem = [];
    const offerCode = isSatellite ? item?.offerCodeSatellite : item?.offerCode;
    let epochPackageName = "";
    epochSvodsData && Object.keys(epochSvodsData || {})?.forEach?.((key: string) => {
      epochSvodsData && epochSvodsData?.[key]?.forEach?.((svod: any) => {
        if (svod?.code === offerCode && filteredPackages?.[key]) {
          packageListSystem?.push?.(filteredPackages?.[key]);
        }
        if( svod?.code === offerCode && svod?.name) {
          epochPackageName = svod?.name;
        }
      });
    });
    return {
      ...item,
      packageListSystem: packageListSystem ? packageListSystem : [],
      name: epochPackageName ? epochPackageName : item?.name ? item?.name : ""
    };
  }) || [];

  // When given svodMapping in params adding genrePacks each svod belongs to
  if( svodMapping ) {
    embeddedSvods?.forEach(svod => {
      const genrePacks = []
      const offerCode = isSatellite ? svod?.offerCodeSatellite : svod?.offerCode;
      svodMapping && Object.keys(svodMapping || {})?.forEach(genre => {
        svodMapping?.[genre]?.forEach(id => {
          if(id === offerCode) {
            genrePacks?.push(genre);
          }
        })
      })
      svod.genrePacks = genrePacks;
    })
  }

  // Component Specific Filtering and Parsing
  // This is to ensure that we only send the data required by the component
  switch (componentType) {
    case ComponentNames?.CHANNEL_LISTING_PAGE:
    case ComponentNames?.SATELLITE_CHANNEL_LISTING_PAGE :{
      // filterOut only SVODs that are enabled through CMS
      embeddedSvods = enabledSvodFilterChlup(embeddedSvods);
      // Embedded & Included Parser to send only Data Required by component
      const parsedComponentData = embeddedSVODParserChlup(embeddedSvods, signaturePackages, isSatellite);
      return parsedComponentData || [];
    }
    case ComponentNames?.PLANCARD: {
      // filterOut only SVODs that are enabled through CMS
      embeddedSvods = enabledSvodFilterPlanCards(embeddedSvods, excludedSvods, isSatellite);
      // Embedded & Included Parser to send only Data Required by component
      const parsedComponentData = embeddedSVODParserPlanCards(embeddedSvods);
      return parsedComponentData || [];
    }
    case ComponentNames?.INPAGECHANNELPACKLINEUP: {
      return enabledSvodFilterInPageChlup(embeddedSvods, pkgId, pkgType);
    }
    case ComponentNames?.CHLUP_INTERACTIVE_TOOL: {
      // filterOut only SVODs that are enabled through CMS
      embeddedSvods = enabledSvodFilterInteractiveTool(embeddedSvods, isSatellite);
      embeddedSvods = singlePackageFilterInteractiveTool({
        embeddedSvods,
        singlePackageView,
        singlePackageConfig
      });
      // Embedded & Included Parser to send only Data Required by component
      const parsedComponentData = embeddedSVODParserInteractiveTool(embeddedSvods);
      return parsedComponentData || [];
    }
    default: return embeddedSvods || [];
  }
};

export const enabledSvodFilterInPageChlup = (
  embeddedSvods: ISBEmbeddedSvods[] = [],
  pkgId?: string,
  pkgType?: string
) => embeddedSvods
  .filter(svod => {
    // Only include SVODs that are not disabled
    const item = svod.inPageChlupData;
    return item && item.disable !== true &&
        (!pkgId || !pkgType || ((pkgType === "genre" ? svod.genrePacks : svod.packageListSystem) ?? []).includes(pkgId));
  })
  .map(svod => {
    const item = svod.inPageChlupData;
    return {
      ...item,
      icon: item.icon,
      name: svod.displayName || svod.name
    };
  });

export const enabledSvodFilterChlup = (embeddedSvods: ISBEmbeddedSvods[]) => (
  embeddedSvods?.filter?.((svod: ISBEmbeddedSvods) => svod?.chlupData?.disable === false)?.filter?.(svod => svod?.packageListSystem?.length > 0) || []
);

export const embeddedSVODParserChlup = (embeddedSvods: ISBEmbeddedSvods[], signaturePackages, isSatellite) => {
  const packages = signaturePackages?.filter?.(pkg => pkg?.category === "ENGLISH" || pkg?.categoryId === "ENGLISH") || [];
  // Parse the embedded SVODs to extract relevant data
  return embeddedSvods?.map?.((svod: ISBEmbeddedSvods) => {
    const { name, chlupData } = svod;
    return {
      name: svod.displayName || name,
      icon: chlupData?.icon,
      svodDeviceIncludedText: chlupData?.deviceIncludedText,
      indicators: Array.from({ length: packages?.length || 0 })?.map?.((_, ix) => {
        const satPkgId = packages?.[ix]?.packageId || packages?.[ix]?.id
        const transformedPackageId = isSatellite ? satPkgId?.replace(/^(ATT(_TV)?|DTV(_TV)?)_(.*)$/, 'DTV_TV_$4') : packages?.[ix]?.id ;
        return svod?.packageListSystem?.includes?.(transformedPackageId) ? 1 : null;
      }),
      chnlPackages: svod?.packageListSystem || []
    };
  }) || [];
}

export const enabledSvodFilterPlanCards = (embeddedSvods: ISBEmbeddedSvods[], excludedSvods: any, isSatellite: boolean) => {
  const excludedSvodsMap = excludedSvods?.reduce((state: any, iterator: any) => {
    state[iterator?.id] = iterator?.excludedPackages || [];
    return state;
  }, {});
  // Filter out the SVODs that are not enabled
  return embeddedSvods?.map?.((svod: ISBEmbeddedSvods) => {
    const offerCode = isSatellite ? svod?.offerCodeSatellite : svod?.offerCode;
    // Filter out excluded packages using global config
    let filteredPackageListSystem = svod?.packageListSystem?.filter((pkg: any) => !svod?.planCardsData?.excludedPackages?.includes(pkg)) || [];
    // Filter out excluded packages on page level
    filteredPackageListSystem = filteredPackageListSystem?.filter((pkg: any) => !excludedSvodsMap?.[offerCode]?.includes(pkg)) || [];
    return {
      ...svod,
      packageListSystem: filteredPackageListSystem
    };
  })?.filter((svod: any) => svod?.packageListSystem?.length > 0);
}

export const embeddedSVODParserPlanCards = (embeddedSvods: ISBEmbeddedSvods[]) => (
  embeddedSvods?.map?.((svod: ISBEmbeddedSvods) => {
    const { name, planCardsData } = svod;
    return {
      name: svod.displayName || name,
      planCardsData,
      packageListSystem: svod?.packageListSystem
    };
  }) || []
);

export const enabledSvodFilterInteractiveTool = (embeddedSvods: ISBEmbeddedSvods[], isSatellite: boolean) => {
  const packageListSystemOrder = isSatellite ? ["DTV_TV_ENTERTAINMENT", "DTV_TV_CHOICE", "DTV_TV_ULTIMATE", "DTV_TV_PREMIER"] : ["ATT_TV_ENTERTAINMENT", "ATT_TV_CHOICE", "ATT_TV_ULTIMATE", "ATT_TV_PREMIER"];

  embeddedSvods?.forEach?.(svod => {
    const packages = [...(svod.packageListSystem || [])]
    const packageListSystemOrdered = []
    packageListSystemOrder.forEach(pkg => {
      if(packages.includes(pkg)) {
        packageListSystemOrdered.push(pkg)
        packages.splice(packages.indexOf(pkg), 1);
      }
    })
    svod.packageListSystem = [...packageListSystemOrdered, ...packages];
  })

  return embeddedSvods?.filter?.((svod: ISBEmbeddedSvods) => svod?.interactiveToolData?.disable === false)?.filter?.(svod => (svod?.packageListSystem?.length > 0 || svod?.genrePacks?.length > 0)) || [];
}

// Generated by Copilot- Start
const ensureArray = <T>(value?: T[]): T[] => (Array.isArray(value) ? value : []);

const includesPackageId = (collection: string[] | undefined, packageId: string): boolean => (packageId ? ensureArray(collection).includes(packageId) : false);

export const singlePackageFilterInteractiveTool = (args: {
  embeddedSvods: ISBEmbeddedSvods[];
  singlePackageView?: boolean;
  singlePackageConfig?: any;
}) => {
  const { embeddedSvods, singlePackageView, singlePackageConfig } = args;
  const normalizedSvods = ensureArray(embeddedSvods);
  const { packageId = "", type } = singlePackageConfig || {};

  if (!singlePackageView || !packageId) {
    return normalizedSvods;
  }

  const matcher =
    type === "genre" ?
      (svod: ISBEmbeddedSvods) => includesPackageId(svod?.genrePacks, packageId) :
      (svod: ISBEmbeddedSvods) => includesPackageId(svod?.packageListSystem, packageId);

  return normalizedSvods.filter(matcher);
};

export const embeddedSVODParserInteractiveTool = (embeddedSvods: ISBEmbeddedSvods[]) => {
  const normalizedSvods = ensureArray(embeddedSvods);

  return normalizedSvods.map((svod: ISBEmbeddedSvods) => {
    const {
      name = "",
      displayName = "",
      interactiveToolData = {},
      offerCode = "",
      packageListSystem,
      genrePacks
    } = svod || ({} as ISBEmbeddedSvods);

    return {
      name: displayName || name,
      offerCode,
      interactiveToolData,
      packageListSystem: ensureArray(packageListSystem),
      genrePacks: ensureArray(genrePacks)
    };
  });
};
// Generated by Copilot- End
